import loggedUserRedirect from '~~/modules/auth/composables/useAuthRedirect'
import fetchUserIsLogged from '~~/modules/api/rurality/v3/user/is-logged'

export default defineNuxtRouteMiddleware(async to => {
  // skip middleware on client side entirely
  if (import.meta.client) return

  const reqHeaders = useRequestHeaders(['referer'])

  let previousUrl: false | string = false

  // the referrer comes when there has been a normal navigation, for example clicking an <a> link in a page. It comes from the http headers
  if (reqHeaders.referer !== undefined) {
    const pathOnly = new URL(reqHeaders.referer).pathname
    previousUrl = pathOnly
  }
  // the redirectedFrom comes when there has been a server side redirection with navigateTo a external: false. It comes from the vue-router
  else if (to.redirectedFrom?.path) {
    previousUrl = to.redirectedFrom.path
  }

  const returnUrl = useCookie('returnUrl', { maxAge: 900 })

  const loginRoute = '/login'
  const travelerRegisterRoute = '/viajero/registro'
  const ownerRegisterRoute = '/propietario/casa/nueva'
  const authRoutes = [loginRoute, travelerRegisterRoute, ownerRegisterRoute]

  const privateRoutes = ['/private']

  const newOwnerLanding = '/aumenta-tus-reservas'

  if (
    authRoutes.includes(to.path) ||
    privateRoutes.some(route => to.path.startsWith(route))
  ) {
    const authUserIsLogged = await fetchUserIsLogged()
    if (
      previousUrl &&
      previousUrl.includes(newOwnerLanding) &&
      to.path === ownerRegisterRoute &&
      authUserIsLogged.logged === true &&
      authUserIsLogged.type.toLowerCase() === 'traveler'
    ) {
      return navigateTo(routes().ownerRegistrationAsTraveler())
    } else if (
      authRoutes.includes(to.path) &&
      authUserIsLogged.type &&
      authUserIsLogged.id
    ) {
      return navigateTo(
        loggedUserRedirect({
          userType: authUserIsLogged.type,
          userId: authUserIsLogged.id,
          isOwnerRegister: to.path === ownerRegisterRoute,
        }),
        {
          external: true,
        },
      )
    } else if (authUserIsLogged.logged === false) {
      if (privateRoutes.some(route => to.path.startsWith(route))) {
        returnUrl.value = to.path
        return navigateTo(routes().login())
      } else if (authRoutes.includes(to.path) && previousUrl) {
        if (!authRoutes.includes(previousUrl) && !returnUrl.value) {
          returnUrl.value = previousUrl
        }
      }
    }
  }

  return
})
